import React, { useState } from "react";
import { copyToClipboard } from "../utils/clipboard";
import Button from "./Button";

export function CopyToClipboardButton({
    text,
    className,
    disabled,
    iconStyleClass = "fal",
    onCopy
}: {
    text: string;
    className?: string;
    iconStyleClass?: string;
    disabled?: boolean;
    onCopy?: () => void;
}) {
    const [copyButtonStatus, setCopyButtonStatus] = useState("inactive");

    const copyToClipboardAction = async () => {
        const copied = await copyToClipboard(text);
        if (!copied) return;
        onCopy?.();
        setCopyButtonStatus("active");
        setTimeout(() => {
            setCopyButtonStatus("inactive");
        }, 2000);
    };

    return (
        <Button
            type={copyButtonStatus === "inactive" ? "ghost" : "purbo-ghost"}
            size="small"
            shape="circle"
            onClick={copyToClipboardAction}
            className={className}
            disabled={disabled}
            title={copyButtonStatus === "inactive" ? "Copy" : "Copied"}
        >
            <i
                className={`${iconStyleClass} ${copyButtonStatus === "inactive" ? "fa-copy" : "fa-check"} !m-0`}
            ></i>
        </Button>
    );
}
